module.exports = __webpack_public_path__ + "images/icons/icon-step-billing-address-753e96d1.svg";